<script setup>
  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    event: {
      type: Object,
      required: true
    }
  });
</script>

<template>
  <p
    class="jwx-tide-spot__event"
    :data-is-next="props.event.isNext"
    :data-is-past="props.event.isPast"
    :data-event-type="props.event.type"
  >
    <Icon :name="props.event.iconName" class="jwx-tide-spot__event-icon" />
    <span class="jwx-tide-spot__event-name">{{ props.event.eventName }}</span>
    <span class="jwx-tide-spot__event-time" v-html="props.event.timeFormattedWithTimezone"></span>
    <span class="jwx-tide-spot__event-value">{{ props.event.eventValue }}</span>
  </p>
</template>